import { ConfigService, SystemUrlService } from "@xo/client-common";

export class Type5BooleanUrlService extends SystemUrlService {
    constructor(system: string, configService: ConfigService) {
        super(system, "SpecApp", "Type5Boolean", configService);
    }
}
